<div class="login_page ng-scope">
  <div class="login-wrapper ng-scope">
    <div id="login" class="login loginpage col-lg-offset-4 col-lg-4 col-md-offset-3 col-md-6 col-sm-offset-3 col-sm-6 col-xs-offset-2 col-xs-8">
      <h1><a href="javascript:;" title="Login Page" tabindex="-1">Fous Tele Ophthalmology - Account Management</a></h1>
      <form name="form" class="form-validation" novalidate (ngSubmit)="pwdResetFormSubmit()" #pwdResetForm="ngForm">
        <div class="text-danger text-center message">
          Password Reset.
        </div>
        <div class="mTop15">
          <input type="password" [(ngModel)]="currentPassword" #password="ngModel" name="pwd" id="currentpwd" class="form-control"
            placeholder="Enter current password*" required />
          <!--<div [hidden]="currentPassword.valid || currentPassword.pristine" class="danger-text">
            Password is required
          </div>-->
        </div>
        <div class="mTop15">
          <input type="password" [(ngModel)]="newPassword" #password="ngModel" name="pwd" id="newpwd" class="form-control"
            placeholder="Enter new password*" required (keyup)="isStrongPassword = checkStrongPassword(newPassword)"/>
            <!-- start : strong password check-->
            <div>
              <span *ngIf="newPassword && newPassword.length>0 && isStrongPassword" style="background-color:#27c24c;color:white;padding:2px;padding-left: 5px;padding-right: 5px;"><i class="fa fa-check-circle">&nbsp;</i>Strong Password</span>
              <span *ngIf="newPassword && newPassword.length>0 && !isStrongPassword" style="background-color:#f05050;color:white;padding:2px;padding-left: 5px;padding-right: 5px;"><i class="fa fa-times-circle">&nbsp;</i>Weak Password</span>
              <span class="pull-right"><a (click)="showPasswordPolicy = !showPasswordPolicy" style="cursor: pointer;color: darkcyan;font-size: 14px;"><span *ngIf="!showPasswordPolicy">Show</span><span *ngIf="showPasswordPolicy">Hide</span> password policy</a></span>
          </div>
          <div *ngIf="showPasswordPolicy">
          <span style="font-style: italic;font-size: 14px;">
              Password must contain
              <ol><li>Minimum 8 letters</li>
                  <li>At least 1 uppercase character</li>
                  <li>At least 1 lowercase character</li>
                  <li>At least 1 number</li>
                  <li>At least 1 special character</li>
              </ol>
          </span>
          </div>
          <!-- end : strong password check-->
          <!--<div [hidden]="newPassword.valid || newPassword.pristine" class="danger-text">
            Password is required
          </div>-->
        </div>
        <div class="mTop15">
          <input type="password" [(ngModel)]="confirmPassword" #confirmPwd="ngModel" name="confirmPwd" id="confirmPwd"
            class="form-control" placeholder="Confirm password*" required />
          <!--<div [hidden]="confirmPwd.valid || confirmPwd.pristine" class="danger-text">
            Confirm Password is required
          </div>-->
          <div *ngIf="(confirmPassword != null && confirmPassword.length>0) && (newPassword!=null && newPassword.length>0) && confirmPassword != newPassword" class="danger-text">
            Confirm Password did not match
          </div>
        </div>
        <p class="submit">
          <button [disabled]="!pwdResetForm.form.valid || currentPassword==null || newPassword==null || confirmPassword==null || confirmPassword != newPassword || !isStrongPassword" type="submit"
            class="btn btn-accent btn-block  btn-primary" style="font-size:16px" *ngIf="!passwordResetSuccess">Reset
            Password
          </button>
        </p>
      </form>
      <p id="nav">
        <label *ngIf="passwordResetSuccess" (click)="backToLoginPage()" style="cursor: pointer;text-transform: inherit;text-align: center;">Password changed successfully. Click here to login </label>
      </p>
    </div>
  </div>
</div>
